import * as React from "react";
import { TTagModule } from "../../../../services/playground";
import { CategoryWrapper, CategoryBox, ControllerArrow, CategoryFloatWrapper } from "./styles";
import { CSSProperties } from "react";
import { isNotBlankArray } from "utils/array";

const activeTabStyle = (lightColor: string = "#fff", backgroundColor: string = "#ff5a00") => {
	return {
		color: lightColor,
		backgroundColor,
	};
};
const defaultTabStyle = (color: string = "#333") => {
	return {
		color,
	};
};

export interface ProductTagsProps<T> {
	style?: CSSProperties;
	className?: string;
	activeTab?: string;
	activeTabIndex?: number;
	canScrollFixed: boolean;
	stickToTop: number;
	tagGroup: T[];
	width?: number | string;
	onChange: (item: T, index: number, fixed: boolean) => void;
}
export interface ProductTagsState {
	fixed: boolean;
}

export interface ProductTagProps {
	fixed: boolean;
	hasExpand: boolean;
}
export interface ProductTagState {
	expanded: boolean | undefined;
	activeTab?: string;
}
class ProductTag<P extends TTagModule> extends React.Component<
	ProductTagsProps<P> & ProductTagProps,
	ProductTagState
> {
	constructor(props: ProductTagsProps<P> & ProductTagProps) {
		super(props);
		this.state = {
			expanded: props.hasExpand,
			activeTab: props.activeTab,
		};
	}

	handelClickItem = (item: P, index: number) => () => {
		this.setState(
			{
				activeTab: item.id,
			},
			() => {
				this.props.onChange(item, index, this.props.fixed);
			},
		);
	};

	getListStyle = (item: TTagModule, nextActiveTab: string = ""): CSSProperties => {
		const { activeTabIndex } = this.props;
		let isAcitve = item.id === nextActiveTab;
		if (activeTabIndex) {
			isAcitve = item.positionId === `${nextActiveTab}|${activeTabIndex}`;
		}

		return isAcitve
			? activeTabStyle(item.text.lightColor, item.focusBgColor)
			: defaultTabStyle(item.text.color);
	};

	render() {
		const { tagGroup, hasExpand } = this.props;
		const { expanded, activeTab } = this.state;
		const expanded1 = expanded !== undefined ? expanded : hasExpand;
		const nextActiveTab = activeTab || tagGroup[0]?.id || "";
		return (
			<CategoryBox width={this.props.width} hasExpand={hasExpand} expanded={expanded1}>
				{tagGroup.map((item, index) => (
					<li
						key={index}
						data-id={item.id}
						onClick={this.handelClickItem(item, index)}
						style={this.getListStyle(item, nextActiveTab)}
					>
						{item.text.content}
					</li>
				))}
				{hasExpand && (
					<ControllerArrow
						onClick={() => this.setState({ expanded: !expanded1 })}
						className={expanded1 ? "arrowUp" : "arrowDown"}
					/>
				)}
			</CategoryBox>
		);
	}
}

class ProductTags<P extends TTagModule> extends React.Component<
	ProductTagsProps<P>,
	ProductTagsState
> {
	private navWrapRef: React.RefObject<HTMLDivElement> = React.createRef();
	private placeholderRef: React.RefObject<HTMLDivElement> = React.createRef();
	constructor(props: ProductTagsProps<P>) {
		super(props);
		this.state = {
			fixed: false,
		};
	}

	static defaultProps = {
		canScrollFixed: true,
		stickToTop: 0,
	};

	componentDidMount(): void {
		const { canScrollFixed } = this.props;
		if (canScrollFixed) {
			window.addEventListener("scroll", this.onScroll);
		}
	}
	componentWillUnmount(): void {
		window.removeEventListener("scroll", this.onScroll);
	}

	onScroll = () => {
		const { stickToTop } = this.props;
		if (!this.navWrapRef || !this.placeholderRef) {
			return;
		}
		const navWrapCurrent = this.navWrapRef.current as HTMLElement;
		const placeHolderCurrent = this.placeholderRef.current as HTMLElement;
		const navToTop = navWrapCurrent.getBoundingClientRect().top;
		const parentNode = navWrapCurrent.parentNode as HTMLDivElement;
		const parentToBottom = parentNode.getBoundingClientRect().bottom;
		if (this.state.fixed) {
			if (
				placeHolderCurrent.getBoundingClientRect().top >= stickToTop ||
				parentToBottom <= stickToTop
			) {
				this.setState({ fixed: false });
			}
			return;
		}
		if (navToTop <= stickToTop && parentToBottom > stickToTop && !this.state.fixed) {
			this.setState({ fixed: true });
		}
	};
	render() {
		const { fixed } = this.state;
		const { tagGroup = [], stickToTop = 0 } = this.props;
		if (!isNotBlankArray(tagGroup)) {
			return null;
		}
		const ProductTag1 = React.forwardRef((props, ref: any) => (
			<CategoryWrapper
				ref={ref}
				{...props}
				style={{
					backgroundColor: tagGroup[0]?.bgColor || "#fff",
				}}
			>
				<ProductTag {...this.props} fixed={false} hasExpand={!!tagGroup[0]?.tabExpand} />
			</CategoryWrapper>
		));
		const ProductTag2 = React.forwardRef((props, ref: any) => (
			<CategoryFloatWrapper
				ref={ref}
				{...props}
				isFixed={fixed}
				scrollTop={stickToTop}
				style={{
					backgroundColor: tagGroup[0]?.bgColor || "#fff",
				}}
			>
				{fixed && (
					<ProductTag
						{...this.props}
						fixed={fixed}
						hasExpand={!!tagGroup[0]?.tabExpand}
					/>
				)}
			</CategoryFloatWrapper>
		));
		return (
			<React.Fragment key={`${this.props.activeTab}_${tagGroup?.length}_${fixed}`}>
				<ProductTag1
					key={`placeholder_${this.props.activeTab}_${tagGroup?.length}`}
					ref={this.placeholderRef}
				/>
				<ProductTag2
					key={`category_${this.props.activeTab}_${tagGroup?.length}`}
					ref={this.navWrapRef}
				/>
			</React.Fragment>
		);
	}
}

export default ProductTags;
